// import {isEmpty} from 'lodash';
import { serviceMaker, methods, api } from "./index.js";
export const getAll = () =>
  serviceMaker(
    `/runreports/FullReportList?genericResultSet=false&parameterType=true`,
    methods.GET,
    api.NGB
  );
export const getAllReport = () =>
  serviceMaker(
    `/runreports/FullReportList?genericResultSet=false&parameterType=true`,
    methods.GET,
    api.NGB
  );
export const getReport = (Name) =>
  serviceMaker(
    `/runreports/FullParameterList?R_reportListing=${Name}&parameterType=true`,
    methods.GET,
    api.NGB
  );
export const getDropdown = () =>
  serviceMaker(
    `/runreports/OfficeIdSelectOne?parameterType=true`,
    methods.GET,
    api.NGB
  );
export const getpaymentDropdown = () =>
  serviceMaker(
    `/runreports/pmtModeSelectAll?parameterType=true`,
    methods.GET,
    api.NGB
  );
export const getrecords = (payload) => {
  const queryString = Object.keys(payload)
    .filter((key) => key !== "Header")
    .map((key) => `R_${key}=${encodeURIComponent(payload[key])}`)
    .join("&");
  const url = `/runreports/${encodeURIComponent(
    payload.Header
  )}?${queryString}`;
  return serviceMaker(url, methods.GET, api.NGB);
};
